module.exports = __webpack_public_path__ + "static/ranthambore2-a74e66d28acfadaf2074ee53cc30ccc2.jpg";